import { InputTemplateType } from '@lmt/shared-types';
import { useSubtenants } from '@lmt/unicorn-shared/app/features/subtenants/selectors';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { useState } from 'react';
import { Field } from '../../common/Field';
import { DropDownInput } from '../../common/ui-kit/inputs/dropdown/DropDownInput';
import { FormComponentProps } from '../../global-forms/GlobalForms.types';
import { InputTemplatesTable } from './components/InputTemplatesTable';
import styles from './InputTemplateForm.module.scss';

export type Props = FormComponentProps & {
  templateType: InputTemplateType;
  isNumber: boolean;
  fieldId: number | null;
  subtenantId?: number;
  isMultiline: boolean;
};

export const InputTemplateForm: React.FC<Props> = React.memo(
  function InputTemplateForm(props) {
    const { fieldId, isNumber, templateType } = props;
    const i18n = useScopedTranslation('input_templates.form');
    const subtenants = useSubtenants();
    const [currentSubtenantId, setCurrentSubtenantId] = useState<number>(
      props.subtenantId ?? subtenants[0].id,
    );

    return (
      <div className={styles['form-container']}>
        <Field title={i18n.t('subtenant')} className={styles.field}>
          <DropDownInput
            useIdFunctionAsValue={true}
            required
            variant="normal"
            getOptionLabel="name"
            idFunction="id"
            options={subtenants}
            value={currentSubtenantId}
            onValueChanged={(option) => {
              setCurrentSubtenantId(option!.id);
            }}
          />
        </Field>
        <InputTemplatesTable
          subtenantId={currentSubtenantId}
          templateType={templateType}
          fieldId={fieldId}
          isNumber={isNumber}
          isMultiline={props.isMultiline}
        />
      </div>
    );
  },
);
